/** Formatage monétaire des sections de rapport.
 *  Le projet n'a pas de helper partagé : chaque composant le redéfinit via
 *  Intl.NumberFormat (cf. PayoutsAnalyticsSection.tsx:371). On en centralise un
 *  ici plutôt que de le dupliquer dans les quatre sections. */
export function formatCurrency(amount: number, currency: string): string {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

/** Couleur PnL de l'UI applicative : emerald / rouge.
 *  Le teal #00C9A7 est réservé au rendu d'image sociale (Satori). */
export function pnlTextClass(amount: number): string {
  return amount >= 0 ? "text-emerald-500" : "text-red-500";
}

/** Interpolation minimale du jeton {count} des chaînes i18n. */
export function withCount(template: string, count: number): string {
  return template.replace("{count}", String(count));
}
